import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import moment from "moment";
import { ReactComponent as NewDesignIcon } from "../../../../assets/svg/NewDesignIcon.svg";
import { ReactComponent as NewRenovationIcon } from "../../../../assets/svg/NewRenovationIcon.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/svg/ArrowIcon.svg";
import { ReactComponent as SmallDhiramIcon } from "../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../utils/CurrencyUtils";
import {
  formattedAmount,
  formattedAmountWithoutAed,
  newFormattedAmount,
} from "../../../../utils/CommonFunction";
import styles from "./styles";
import { isEmpty } from "lodash";

const MilestoneBudgetList = ({ proposalDetails }) => {
  const [expandedMilestones, setExpandedMilestones] = useState(
    proposalDetails?.milestone?.map((item) => item.id) || []
  );

  const toggleMilestone = (milestoneId) => {
    setExpandedMilestones((prevExpanded) =>
      prevExpanded.includes(milestoneId)
        ? prevExpanded.filter((id) => id !== milestoneId)
        : [...prevExpanded, milestoneId]
    );
  };

  return (
    <>
      {!isEmpty(proposalDetails?.milestone) && (
        <>
          <h3 style={styles.sub_heading}>Milestones & Budget Items</h3>
          <div style={{ ...styles.columnFlex }}>
            {proposalDetails?.milestone?.map((item) => (
              <div key={item.id}>
                <div
                  style={{
                    ...styles.rowFlex,
                    justifyContent: "space-between",
                    borderRadius: "12px",
                    background: "#F7F7F7",
                    padding: "1vh 1vw",
                    alignItems: "center",
                  }}
                >
                  <div style={{ ...styles.rowFlex, flex: 1 }}>
                    <Box display="flex" alignItems="center">
                      <Box
                        component="img"
                        src={
                          item?.milestone_image
                            ? item?.milestone_image?.path
                            : "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                        }
                        alt="Project Icon"
                        sx={{
                          width: 40,
                          height: 40,
                          borderRadius: "8px",
                          border: "2px solid white",
                          boxShadow: "0px 4px 2.67px 0px #00000026",
                          marginRight: 1,
                        }}
                      />
                      <span style={styles.small_sub_heading}>
                        {item?.milestone_name}
                      </span>
                    </Box>
                  </div>
                  <div style={{ ...styles.rowFlex, flex: 1 }}>
                    <div style={styles.small_text}>
                      <div style={{ ...styles.rowFlex }}>
                        {item?.tags === "Design" ? (
                          <NewDesignIcon />
                        ) : (
                          <NewRenovationIcon />
                        )}
                        {item?.tags}
                      </div>
                    </div>
                  </div>
                  <div style={{ ...styles.rowFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Start</h3>
                    <div style={styles.small_sub_heading}>
                      {moment(item?.start_date).format("MMM DD, YYYY")}
                    </div>
                  </div>
                  <div style={{ ...styles.rowFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>End</h3>
                    <div style={styles.small_sub_heading}>
                      {moment(item?.end_date).format("MMM DD, YYYY")}
                    </div>
                  </div>
                  <div style={{ ...styles.rowFlex, flex: 1 }}>
                    <h3 style={styles.small_text}>Amount</h3>
                    <div
                      style={{
                        ...styles.small_sub_heading,
                        ...styles.rowFlex,
                        gap: "5px",
                      }}
                    >
                      {renderCurrencyIcon('small')}
                      {formattedAmountWithoutAed(item?.amount)}
                    </div>
                  </div>
                  <IconButton onClick={() => toggleMilestone(item.id)}>
                    {expandedMilestones.includes(item.id) ? (
                      <KeyboardArrowUp />
                    ) : (
                      <KeyboardArrowDown />
                    )}
                  </IconButton>
                </div>

                {expandedMilestones?.includes(item.id) && (
                  <div
                    style={{
                      ...styles.columnFlex,
                      ...styles.budgetContainer,
                      gap: "15px",
                      marginBottom: "2vh",
                    }}
                  >
                    {item?.budget?.map((budgetItem) => (
                      <div
                        key={budgetItem.id}
                        style={{
                          ...styles.rowFlex,
                          gap: "0px",
                          alignItems: "flex-start",
                        }}
                      >
                        <ArrowIcon />
                        <div style={styles.budgetRow}>
                          <div style={{ ...styles.rowFlex, flex: 1.5 }}>
                            <Box display="flex" alignItems="center">
                              <Box
                                component="img"
                                src={
                                  !isEmpty(budgetItem?.buget_image)
                                    ? budgetItem?.buget_image[0]?.image
                                    : "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                                }
                                alt="Project Icon"
                                sx={{
                                  width: 35,
                                  height: 35,
                                  borderRadius: "8px",
                                  border: "2px solid white",
                                  boxShadow: "0px 4px 2.67px 0px #00000026",
                                  marginRight: 1,
                                }}
                              />
                              <span style={styles.small_sub_heading}>
                                {budgetItem?.name}
                              </span>
                            </Box>
                          </div>
                          <div style={{ ...styles.columnFlex, flex: 1 }}>
                            <h3 style={styles.small_text}>Material Type</h3>
                            <div style={styles.small_sub_heading}>
                              {budgetItem?.material_type || "-"}
                            </div>
                          </div>

                          <div style={{ ...styles.columnFlex, flex: 1 }}>
                            <h3 style={styles.small_text}>Material Unit</h3>
                            <div style={styles.small_sub_heading}>
                              {budgetItem?.material_unit || "-"}
                            </div>
                          </div>
                          <div style={{ ...styles.columnFlex, flex: 1 }}>
                            <h3 style={styles.small_text}>Manpower Rate</h3>
                            <div style={styles.small_sub_heading}>
                              {budgetItem?.manpower_rate || "-"}
                            </div>
                          </div>
                          <div style={{ ...styles.columnFlex, flex: 1 }}>
                            <h3 style={styles.small_text}>Days</h3>
                            <div style={styles.small_sub_heading}>
                              {budgetItem?.days || "-"}
                            </div>
                          </div>
                          <div style={{ ...styles.columnFlex, flex: 1 }}>
                            <h3 style={styles.small_text}>Unit Cost</h3>
                            <div
                              style={{
                                ...styles.small_sub_heading,
                                ...styles.rowFlex,
                                gap: "5px",
                              }}
                            >
                              {renderCurrencyIcon('small')}
                              {budgetItem?.material_unit_price
                                ? formattedAmountWithoutAed(
                                    budgetItem?.material_unit_price
                                  )
                                : "-"}
                            </div>
                          </div>

                          <div style={{ ...styles.columnFlex, flex: 1 }}>
                            <h3 style={styles.small_text}>Units</h3>
                            <div style={styles.small_sub_heading}>
                              {budgetItem?.qty !== null || budgetItem?.days
                                ? budgetItem.qty || budgetItem?.days
                                : "-"}
                            </div>
                          </div>

                          <div style={{ ...styles.columnFlex, flex: 1 }}>
                            <h3 style={styles.small_text}>Total Cost</h3>
                            <div
                              style={{
                                ...styles.small_sub_heading,
                                ...styles.rowFlex,
                                gap: "5px",
                              }}
                            >
                              {renderCurrencyIcon('small')}
                              {formattedAmountWithoutAed(
                                budgetItem?.total_item
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default MilestoneBudgetList;
